export default __webpack_public_path__ + "static/media/property_47.7fc03daf.png";